import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titleDialog,
    modelValue: _ctx.isModalVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isModalVisible) = $event)),
    class: "bg-light rounded",
    "close-on-click-modal": false,
    draggable: "",
    "destroy-on-close": "",
    top: "2vh",
    onOpen: _ctx.onOpen
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isModalVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancelar")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: _ctx.loading,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'checklist', {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: _ctx.mbtoa(_ctx.rowClub.idinstitution),
                                                d: _ctx.listChecks,
                                                e: _ctx.optionList,
                                                f: _ctx.selectedEvents

                    })))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Descargar ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_radio_group, {
        modelValue: _ctx.optionList,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.optionList) = $event)),
        onChange: _ctx.changeOption
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio, {
            value: "1",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Descargar lista actual")
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio, {
            value: "2",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Mostrar solo los nuevos")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      (_ctx.optionList == '2')
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            modelValue: _ctx.selectedEvents,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedEvents) = $event)),
            multiple: "",
            filterable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listEvents, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: `lst-eve-${index}`,
                  label: item.name,
                  value: item.idevent
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen"]))
}